import { render, staticRenderFns } from "./LhbDetailContent.vue?vue&type=template&id=7284c410&scoped=true"
import script from "./LhbDetailContent.vue?vue&type=script&lang=js"
export * from "./LhbDetailContent.vue?vue&type=script&lang=js"
import style0 from "./LhbDetailContent.vue?vue&type=style&index=0&id=7284c410&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7284c410",
  null
  
)

export default component.exports